import { observer } from "mobx-react-lite";
import { FC, useMemo } from "react";
import styled from "@emotion/styled";
import { PlatformIconKind } from "@/domains/api/types";
import { css, cx } from "@/domains/emotion";
import { PlatformIcon } from "@/components/icons/platform-icon";
import { useTheme } from "@/mds";

interface AppCalloutBannerIconProps {
  iconKind: PlatformIconKind | null;
}

export const AppCalloutBannerIcon: FC<AppCalloutBannerIconProps> = observer(({ iconKind }) => {
  if (!iconKind) return null;

  const { theme } = useTheme();

  // const illustrationSrc =
  //   themeType === "harvest"
  //     ? HeadsUpEmptyStateIllustrationLight
  //     : HeadsUpEmptyStateIllustrationDark;

  const customStyles = useMemo(() => {
    if (iconKind === PlatformIconKind.ThinkingHeads) {
      return css`
        height: 120px;
        width: 120px;
        color: ${theme.colors.background.banner.emphasis};
      `;
    }

    return css({
      height: "80px",
      width: "80px",
    });
  }, [iconKind, theme.colors.background.banner.emphasis]);

  const innerIconStyles = css({
    ".mds-icon": {
      fontSize: "58px",
      color: theme.colors.icon.primary,
    },
  });

  return (
    <IconWrapper>
      <PlatformIcon iconKind={iconKind} className={cx(customStyles, innerIconStyles)} />
    </IconWrapper>
  );
});

const IconWrapper = styled.div({
  paddingTop: "8px",
  paddingBottom: "8px",
  paddingLeft: "8px",
  paddingRight: "32px",
});
